export const DATA_TYPE = {
  // base data type
  ID: 'id',
  STRING: 'string',
  NUMBER: 'number',
  ARRAY: 'array',
  BOOLEAN: 'boolean',
  BOOL: 'boolean',
  DATE: 'date',
  DATE_TIME: 'dateTime',
  OBJECT: 'object',

  // business data type
  EMAIL: 'email',
  PHONE: 'phone',
  PROGRESS: 'progress',
  STATE: 'state',
  DOCUMENT_CODE: 'documentCode',
  DOCUMENT_NAME: 'documentName',
  DOCUMENT_STATE: 'documentState',
  HTML: 'html',
  
  GL_DATE: 'glDate',
  COMPANY_ID: 'companyId',
  DESC_STRING: 'descString',
  POSTED_NUMBER: 'postedNumber'
};

export default DATA_TYPE;
